import script from "./ShopCartAddShippingMethodModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShopCartAddShippingMethodModal.vue?vue&type=script&lang=ts&setup=true"

import "./ShopCartAddShippingMethodModal.vue?vue&type=style&index=0&id=83460f7a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83460f7a"]])

export default __exports__